var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Form } from 'packages/form/entities/Form';
var FormTemplate = /** @class */ (function (_super) {
    __extends(FormTemplate, _super);
    function FormTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = '';
        _this.formUuid = '';
        _this.createdBy = 0;
        _this.updatedAt = '';
        _this.archivedAt = '';
        _this.lastUsedAt = '';
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FormTemplate.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        this.uuid = jsonData.id;
        return this;
    };
    FormTemplate.prototype.toJson = function (toSnake, asString) {
        var json = _super.prototype.toJson.call(this, toSnake, asString);
        json.uuid = json.id;
        return asString ? JSON.stringify(json) : json;
    };
    return FormTemplate;
}(Form));
export { FormTemplate };
